import { useCallback, useState } from "react";
import { AxiosError, AxiosResponse } from "axios";
import { ICollection } from "../../../utils/interfaces/collection.interface";
import { handleBackendError } from "../../../utils/helpers";
import { useTranslation } from "react-i18next";
import { IPaginationParams } from "../../../utils/interfaces/pagination-params.interface";
import { IResource } from "../../../utils/interfaces/resource.interface";
import ProjectTypeRepository from "../../../repositories/project-type-repository";
import { ProjectTypeList } from "../list/interface";
import { ProjectType } from "../../../models/project-type";

export const useGetProjectType = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<ProjectTypeList[]>([]);
  const [totalData, setTotalData] = useState<number>(0);
  const [isOnFetchingData, setIsOnFetchingData] = useState<boolean>(false);

  const [projectTypeData, setProjectTypeData] = useState<ProjectType | null>(
    null
  );
  const [isOnFetchingProjectTypeData, setIsOnFetchingProjectTypeData] =
    useState<boolean>(false);

  const loadData = useCallback(async (params: IPaginationParams) => {
    setIsOnFetchingData(true);

    await ProjectTypeRepository.all(params)
      .then((response: AxiosResponse<ICollection<ProjectTypeList[]>>) => {
        setData(response.data.data);
        setTotalData(response.data.meta.total);
      })
      .catch(() => {})
      .finally(() => {
        setIsOnFetchingData(false);
      });
  }, []);

  const loadProjectTypeData = useCallback(
    async (id: string, params: any = null) => {
      setIsOnFetchingProjectTypeData(true);

      await ProjectTypeRepository.show(id, params)
        .then((response: AxiosResponse<IResource<ProjectType>>) => {
          setProjectTypeData(response.data.data);
        })
        .catch((e: AxiosError) => {
          handleBackendError(e, t("notification.error.default"));
        })
        .finally(() => {
          setIsOnFetchingProjectTypeData(false);
        });
    },
    [t]
  );

  return {
    data,
    totalData,
    loadData,
    isOnFetchingData,
    loadProjectTypeData,
    isOnFetchingProjectTypeData,
    projectTypeData,
  };
};
